/**
 * KFZ Endkundenrechner-API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent, HttpContext 
        }       from '@angular/common/http';
import { Observable }                                        from 'rxjs';
import { OpenApiHttpParams, QueryParamStyle } from '../query.params';

// @ts-ignore
import { KfzRestoreTaskResponse } from '../model/kfz-restore-task-response.model';
// @ts-ignore
import { KfzSaveTaskRequest } from '../model/kfz-save-task-request.model';
// @ts-ignore
import { KfzWeitereTarifeResponse } from '../model/kfz-weitere-tarife-response.model';
// @ts-ignore
import { SaveTaskResponse } from '@comparit/common-api';
// @ts-ignore
import { UpdateKfzTaskRequest } from '../model/update-kfz-task-request.model';

// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';
import { BaseService } from '../api.base.service';
import {
    KfzTaskServiceInterface,
    GetKfzWeitereTarifeRequestParams,
    ResetKfzTaskRequestParams,
    RestoreKfzTaskRequestParams,
    SaveKfzTaskRequestParams,
    UpdateKfzTaskRequestParams
} from './kfz-task.serviceInterface';



@Injectable({
  providedIn: 'root'
})
export class KfzTaskService extends BaseService implements KfzTaskServiceInterface {

    constructor(protected httpClient: HttpClient, @Optional() @Inject(BASE_PATH) basePath: string|string[], @Optional() configuration?: Configuration) {
        super(basePath, configuration);
    }

    /**
     * Liefert die restlichen Rastertarife des Angebots
     * Ergänzt betterOffer.entries aus dem Restore, das nur den Bestandstarif und die drei Vorschläge trägt. Hier kommen die übrigen Tarife des Rasters, aufsteigend nach Bruttobeitrag und ohne gesetzten slot. Das Raster enthält nur Tarife, die ihren höheren Preis mit einem besseren Produktrating rechtfertigen; teurere Tarife ohne besseres Rating erreichen den Kunden nie. Ist das Angebot abgelaufen oder belegt jeder Rastertarif einen Platz, ist entries leer. betterOffer.anzahlWeitereTarife sagt vorab, ob es etwas zu holen gibt.
     * @endpoint get /api/sparte-kfz/task/{taskId}/weitere-tarife
     * @param requestParameters
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional options
     * @deprecated
     */
    public getKfzWeitereTarife(requestParameters: GetKfzWeitereTarifeRequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<KfzWeitereTarifeResponse>;
    public getKfzWeitereTarife(requestParameters: GetKfzWeitereTarifeRequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<KfzWeitereTarifeResponse>>;
    public getKfzWeitereTarife(requestParameters: GetKfzWeitereTarifeRequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<KfzWeitereTarifeResponse>>;
    public getKfzWeitereTarife(requestParameters: GetKfzWeitereTarifeRequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        const session = requestParameters?.session;
        const taskId = requestParameters?.taskId;
        if (taskId === null || taskId === undefined) {
            throw new Error('Required parameter taskId was null or undefined when calling getKfzWeitereTarife.');
        }
        const kundeToken = requestParameters?.kundeToken;

        let localVarHeaders = this.defaultHeaders;
        if (kundeToken !== undefined && kundeToken !== null) {
            localVarHeaders = localVarHeaders.set('kundeToken', String(kundeToken));
        }
        if (session !== undefined && session !== null) {
            localVarHeaders = localVarHeaders.set('session', String(session));
        }

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/sparte-kfz/task/${this.configuration.encodeParam({name: "taskId", value: taskId, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: "uuid"})}/weitere-tarife`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<KfzWeitereTarifeResponse>('get', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Setzt einen Task auf den Ausgangszustand seiner Session zurück
     * @endpoint post /api/sparte-kfz/task/{taskId}/reset
     * @param requestParameters
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional options
     * @deprecated
     */
    public resetKfzTask(requestParameters: ResetKfzTaskRequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<KfzRestoreTaskResponse>;
    public resetKfzTask(requestParameters: ResetKfzTaskRequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<KfzRestoreTaskResponse>>;
    public resetKfzTask(requestParameters: ResetKfzTaskRequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<KfzRestoreTaskResponse>>;
    public resetKfzTask(requestParameters: ResetKfzTaskRequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        const session = requestParameters?.session;
        const taskId = requestParameters?.taskId;
        if (taskId === null || taskId === undefined) {
            throw new Error('Required parameter taskId was null or undefined when calling resetKfzTask.');
        }
        const kundeToken = requestParameters?.kundeToken;

        let localVarHeaders = this.defaultHeaders;
        if (kundeToken !== undefined && kundeToken !== null) {
            localVarHeaders = localVarHeaders.set('kundeToken', String(kundeToken));
        }
        if (session !== undefined && session !== null) {
            localVarHeaders = localVarHeaders.set('session', String(session));
        }

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/sparte-kfz/task/${this.configuration.encodeParam({name: "taskId", value: taskId, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: "uuid"})}/reset`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<KfzRestoreTaskResponse>('post', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Stellt die gespeicherten Berechnungsvorgaben für eine KFZ-Berechnung wieder her
     * @endpoint get /api/sparte-kfz/task/restore
     * @param requestParameters
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional options
     * @deprecated
     */
    public restoreKfzTask(requestParameters: RestoreKfzTaskRequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<KfzRestoreTaskResponse>;
    public restoreKfzTask(requestParameters: RestoreKfzTaskRequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<KfzRestoreTaskResponse>>;
    public restoreKfzTask(requestParameters: RestoreKfzTaskRequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<KfzRestoreTaskResponse>>;
    public restoreKfzTask(requestParameters: RestoreKfzTaskRequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        const token = requestParameters?.token;
        if (token === null || token === undefined) {
            throw new Error('Required parameter token was null or undefined when calling restoreKfzTask.');
        }
        const kundeToken = requestParameters?.kundeToken;
        const session = requestParameters?.session;

        let localVarQueryParameters = new OpenApiHttpParams(this.encoder);

        localVarQueryParameters = this.addToHttpParams(
            localVarQueryParameters,
            'token',
            <any>token,
            QueryParamStyle.Form,
            true,
        );


        let localVarHeaders = this.defaultHeaders;
        if (kundeToken !== undefined && kundeToken !== null) {
            localVarHeaders = localVarHeaders.set('kundeToken', String(kundeToken));
        }
        if (session !== undefined && session !== null) {
            localVarHeaders = localVarHeaders.set('session', String(session));
        }

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/sparte-kfz/task/restore`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<KfzRestoreTaskResponse>('get', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                params: localVarQueryParameters.toHttpParams(),
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Speichert den aktuellen Berechnungsfortschritt für eine KFZ-Berechnung
     * @endpoint post /api/sparte-kfz/task/save
     * @param requestParameters
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional options
     * @deprecated
     */
    public saveKfzTask(requestParameters: SaveKfzTaskRequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<SaveTaskResponse>;
    public saveKfzTask(requestParameters: SaveKfzTaskRequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<SaveTaskResponse>>;
    public saveKfzTask(requestParameters: SaveKfzTaskRequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<SaveTaskResponse>>;
    public saveKfzTask(requestParameters: SaveKfzTaskRequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        const session = requestParameters?.session;
        const kfzSaveTaskRequest = requestParameters?.kfzSaveTaskRequest;
        if (kfzSaveTaskRequest === null || kfzSaveTaskRequest === undefined) {
            throw new Error('Required parameter kfzSaveTaskRequest was null or undefined when calling saveKfzTask.');
        }
        const kundeToken = requestParameters?.kundeToken;

        let localVarHeaders = this.defaultHeaders;
        if (kundeToken !== undefined && kundeToken !== null) {
            localVarHeaders = localVarHeaders.set('kundeToken', String(kundeToken));
        }
        if (session !== undefined && session !== null) {
            localVarHeaders = localVarHeaders.set('session', String(session));
        }

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/sparte-kfz/task/save`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<SaveTaskResponse>('post', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: kfzSaveTaskRequest,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Aktualisiert einen gespeicherten Task und verlängert dessen Gültigkeit
     * @endpoint put /api/sparte-kfz/task/{taskId}
     * @param requestParameters
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional options
     * @deprecated
     */
    public updateKfzTask(requestParameters: UpdateKfzTaskRequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<SaveTaskResponse>;
    public updateKfzTask(requestParameters: UpdateKfzTaskRequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<SaveTaskResponse>>;
    public updateKfzTask(requestParameters: UpdateKfzTaskRequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<SaveTaskResponse>>;
    public updateKfzTask(requestParameters: UpdateKfzTaskRequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        const session = requestParameters?.session;
        const taskId = requestParameters?.taskId;
        if (taskId === null || taskId === undefined) {
            throw new Error('Required parameter taskId was null or undefined when calling updateKfzTask.');
        }
        const updateKfzTaskRequest = requestParameters?.updateKfzTaskRequest;
        if (updateKfzTaskRequest === null || updateKfzTaskRequest === undefined) {
            throw new Error('Required parameter updateKfzTaskRequest was null or undefined when calling updateKfzTask.');
        }
        const kundeToken = requestParameters?.kundeToken;

        let localVarHeaders = this.defaultHeaders;
        if (kundeToken !== undefined && kundeToken !== null) {
            localVarHeaders = localVarHeaders.set('kundeToken', String(kundeToken));
        }
        if (session !== undefined && session !== null) {
            localVarHeaders = localVarHeaders.set('session', String(session));
        }

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/sparte-kfz/task/${this.configuration.encodeParam({name: "taskId", value: taskId, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: "uuid"})}`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<SaveTaskResponse>('put', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: updateKfzTaskRequest,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

}
